module.exports = {"data":{"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","facebook":{"appId":""}}},"allMarkdownRemark":{"group":[{"fieldValue":"sample","totalCount":1},{"fieldValue":"tag-1","totalCount":1},{"fieldValue":"tag-2","totalCount":1}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags.json
// module id = 420
// module chunks = 55702396619907